<template>
		<div class="trigger-hidden-content d-inline-block">
			<span class=" button">
			{{ item.organization_role[0].display_name }}	<img width="10" src="../../assets/images/icons/solid/ellipsis-h_white.svg">
			</span>
			<div class="hidden-content hc-left"
			style="width: fit-content"> 
			<div>
				<ul class="list-unstyled text-left">
				<template>
					<!-- New User Login SSO -->
				<li v-for="(a,b) in item.organization_role" :key="b">
					<small class="ml-1">{{a.display_name}}</small>
				</li>
				
				</template>
				</ul>
			</div>
			</div>
		</div>
	
</template>

<script>
export default {
	props: ['item']
}
</script>


// WEBPACK FOOTER //
// src/components/shared/TableToolTip.vue